import { useRootSelector } from '../../store/hooks';
import { selectPageConfig } from '../../store/features/pageConfig';
import { CallToActionSelectTypes, HubModuleSiteLink } from '../../types';
import { generateDomainUrl } from '../../helpers/generateDomainUrl';
import CallToActionService from '../../services/CallToActionService';
import { selectOptions } from '../../store/features/options';

export interface SiteOptions {
  tenant: string;
  path: string;
  link?: HubModuleSiteLink;
}

export function useBuildSiteUrl(siteOptions: SiteOptions): string {
  const { tenantId, tenantsConfig: domains } =
    useRootSelector(selectPageConfig);
  const { newPaymentJourneyEnabled } = useRootSelector(selectOptions);
  const { tenant, path, link } = siteOptions;

  switch (link?.selectType) {
    case CallToActionSelectTypes.CUSTOM:
      return link.customUrl;
    case CallToActionSelectTypes.LANDING:
      return generateDomainUrl({
        domains,
        tenant,
        path: `${path}${link.customUrl}`,
      });
    case CallToActionSelectTypes.BASE: {
      const basePagePath = CallToActionService.getLinkDetailsByConfig(
        link as HubModuleSiteLink,
        newPaymentJourneyEnabled,
      ).path;

      return generateDomainUrl({
        domains,
        tenant,
        path: `${path}${basePagePath}`,
      });
    }
  }

  // For the same tenant remove informaconnect.com domain and live only /path
  if (tenantId === tenant) {
    return path.replace(/^(\/+)?/, '/');
  }

  return generateDomainUrl({ domains, tenant, path });
}
